import React, { Component } from 'react'

import { compose } from 'recompose'
import { connect as formikConnect } from 'formik'
import { connect } from 'react-redux'
import withTranslation from 'next-translate/withTranslation'
import { RegistrationApi } from 'SRC/modules/users/Registration/api'
import { getWasSentSms } from 'SRC/modules/ads/add/selectors'
import { setSmsWasSent, setError } from 'SRC/modules/ads/add/actions'

class SmsCodeModal extends Component {
	constructor(props) {
		super(props)

		this.interval = null

		this.state = {
			countdown: 0,
			attempts: 1
		}
	}

	componentWillUnmount() {
		clearInterval(this.interval)
	}

	componentDidMount = prevProps => {
		this.createTimer()
	}

	createTimer = () => {
		clearInterval(this.interval)

		this.setState({ countdown: 120 })
		this.interval = setInterval(this.tick, 1000)
	}

	resendSms = async () => {
		const { formik, setSmsWasSent, setError, i18n: { t } } = this.props

		const selectedDial = formik.values && formik.values.newUser ? formik.values.newUser.dial : ''

		const phone = `${selectedDial}${formik.values.newUser.phone}`.replace('+', '').replace(/ /g, '').trim()

		const regApi = new RegistrationApi()
		const smsResponse = await regApi.sendSmsCode(phone, true)

		console.log('smsResponse', smsResponse)
		if (smsResponse.error) {
			setError(t('common:addAdSmsCodeNotSent'))
		} else {
			const { statusCode } = smsResponse

			if (typeof statusCode !== 'undefined' && (statusCode === 0 || statusCode === 2)) {
				setSmsWasSent(true)
				this.setState(prevState => ({
					...prevState,
					attempts: prevState.attempts + 1
				}))
			}
		}
	}

	submit = async () => {
		const { formik, setSmsWasSent, setError, i18n: { t } } = this.props

		const code = formik.values.newUser && formik.values.newUser.code

		if (code && code.length === 6) {
			console.log('code', code)

			await formik.setFieldValue('newUser.code', code)
			this.setState({ attempts: 1 })

			formik.handleSubmit()
		} else {
			setError(t('common:Pogrešan SMS kod.'))
		}
	}

	getCountdownText = () => {
		const { countdown } = this.state

		let text = ''

		const minutes = Math.floor(countdown / 60)

		let seconds = '0'

		if (countdown % 60 !== 0) {
			seconds = `${countdown % 60}`
		}

		text = `0${minutes}:${seconds.length === 1 ? `0${seconds}` : `${seconds}`}`

		return text
	}

	getHelpComponent = () => {
		const { i18n: { t } } = this.props
		const { attempts, countdown } = this.state

		if (countdown > 0) {
			return (
				<span className='ico-info-popup ico sms-code__left-column'>
					<span className='sms-code__timer'>
						{`${t('common:Ponovo pošalji SMS za')} ${this.getCountdownText()}`}
					</span>
				</span>
			)
		}

		if (attempts > 1) {
			return (
				<span className='ico-info-popup ico sms-code__left-column'>
					<span className='sms-code__fallback-text'>
						{t('common:addAdSmsCodeFallback')}
					</span>
				</span>
			)
		}

		return (
			<span className='ico-info-popup ico sms-code__left-column' onClick={this.resendSms}>
				<span className='sms-code__resend-button'>
					{t('common:POŠALJI PONOVO')}
				</span>
			</span>
		)
	}

	tick = () => {
		const { setSmsWasSent } = this.props
		const { countdown } = this.state

		if (countdown > 0) {
			this.setState({ countdown: countdown - 1 })
		} else {
			// setSmsWasSent(false)
			clearInterval(this.interval)
		}
	}

	render() {
		const { smsWasSent, formik, i18n: { t } } = this.props
		const { attempts } = this.state

		if (!formik.values.newUser) return null

		return (
			<div className='sms-potvrda'>
				<p className='potvrda-msg'>
					{t('common:addAdPotvrdaSms')}
				</p>
				<div className='sms-code__form'>
					<input
						onChange={e => {
							const code = e.target.value
							console.log('code', code)

							formik.setFieldValue('newUser.code', code)
						}}
						maxLength='6'
						name='newUser.code'
						className='unesi-kod-input'
						type='text'
					/>
					<button
						className='potvrdi-btn'
						disabled={formik.isSubmitting}
						onClick={!formik.isSubmitting ? () => this.submit() : null}
					>
						{t('common:Potvrdi')}
					</button>
				</div>
				<div className='sms-code__help-block'>
					{this.getHelpComponent()}
					<span className='sms-code__support-text'>
						{t('common:addAdSmsCodeSupportText')}
					</span>
				</div>
			</div>
		)
	}
}

const mapStateToProps = state => {
	return {
		smsWasSent: getWasSentSms(state)
	}
}

const enhance = compose(
	connect(mapStateToProps, { setSmsWasSent, setError }),
	formikConnect,
	withTranslation
)

export default enhance(SmsCodeModal)
